import request from '@/utils/request.js'

export async function getCaptcha(params) {
  return request({
    url: '/api/config/captcha',
    method: 'get',
    params,
  })
}

export async function getArea(params) {
  return request({
    url: `/api/config/area`,
    method: 'get',
    params,
    timeout: 30 * 1000,
  })
}
